import type { RequestOptions } from 'http';

import type { PokerHomeGames } from '@ps/web-martech-cms-types';
import type {
  ChangeClubOptionsRequest,
  ClubOptionsResponse,
  HgGetClubOptionsReply
} from '@ps/web-shared-api-types/v0/SwHomeGames';
import type { HgChangeClubOptions } from '@ps/web-shared-api-types/v1-preview/SwHomeGames';
import { get } from 'lodash';

import type {
  ExtractDispatchFromModel,
  ExtractSelectFromModel,
  WidgetEffectParams
} from '@swf/core/store';

import { PKR_LOADERS } from '../../constants/constants';
import ENDPOINTS from '../../constants/endpoints';
import type { HomeGamesWidgetModel } from '../model';

export const clubOptions = async (
  {
    clubId,
    method,
    seasonLength,
    ...rest
  }: HgChangeClubOptions & { method?: RequestOptions['method'] },
  { request, dispatch, widget: { uid }, select, rootState }: WidgetEffectParams<PokerHomeGames>
) => {
  const widgetSelect: ExtractSelectFromModel<HomeGamesWidgetModel> = select[uid];
  const widgetDispatch: ExtractDispatchFromModel<HomeGamesWidgetModel> = dispatch[uid];
  const loaderName = PKR_LOADERS.clubOptionsById(Number(clubId));
  const currentOptions = widgetSelect.clubOptionsById(rootState)[Number(clubId)];
  const seasonOption = seasonLength ?? currentOptions?.seasonType;
  // CORE BE needs to remove one of the following duplicating props: seasonLength or seasonType
  const seasonProps = { seasonLength: seasonOption, seasonType: seasonOption };

  widgetDispatch.setLoading({ isLoading: true, loaderName });

  const body = method
    ? ({
        changeClubOptions: {
          ...currentOptions,
          ...seasonProps,
          ...rest
        }
      } as ChangeClubOptionsRequest)
    : { clubId };

  try {
    const response = await request<ClubOptionsResponse>({
      service: ENDPOINTS.clubOptions,
      body,
      method: (method ?? 'GET') as never,
      http: true
    });
    const clubOptionsReply: HgGetClubOptionsReply = get(response, 'body.clubOptionsReply');

    if (response.body?.success) {
      widgetDispatch.setClubOptions({
        response: clubOptionsReply ?? { ...currentOptions, ...seasonProps, ...rest },
        clubId: Number(clubId)
      });
    }
  } finally {
    widgetDispatch.setLoading({ isLoading: false, loaderName });
  }
};
